import { FontAwesome5 } from '@expo/vector-icons';
import React from 'react';
import { Pressable, StyleSheet, Text } from 'react-native';

import Styles from '../styles';
import Colors from '../styles/Colors';
import { KeyProps } from '../types';

export default function Button({ number, icon, onPress }: KeyProps) {
  return (
    <Pressable style={[styles.button]} onPress={() => onPress(number)}>
      <Text style={[styles.text, Styles.text]}>
        {icon ? <FontAwesome5 name={number} size={40} /> : number}
      </Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    width: 80,
    height: 80,
    borderColor: Colors.buttonLight,
    borderWidth: 3,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 5,
  },
  text: {
    fontSize: 50,
  },
});
